const [ w, d ] = [ window, document ]

const init = () => {}

const documentLoaded = () => {
  $.when( w.load['recruit-welfare'] ).then( (data, slot) => {
    $('[data-slot="recruit-welfare"]').html( slot )
  })
  $.when( w.load['recruit-treat'] ).then( (data, slot) => {
    $('[data-slot="recruit-treat"]').html( slot )
  })
  $.when( w.load['recruit-qa'] ).then( (data, slot) => {
    $('[data-slot="qa-list"]').html( slot )
  })
}

export default function RECRUIT () {
  $( init )
  $( documentLoaded )
}